import { FormControl } from '@angular/forms';

export function ValidateChasisNumber(control: FormControl): any {
  if (!control.value) return null;
  const vin: string = control.value.trim();

  if (vin === '') return { required: true };
  else if (vin.length !== 17) return { invalid: true };

  return null;
}
